/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface BookingRewardAuditKey
 */
export interface BookingRewardAuditKey {
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditKey
     */
    bookingType: BookingRewardAuditKeyBookingTypeEnum;
    /**
     *
     * @type {number}
     * @memberof BookingRewardAuditKey
     */
    bookingId: number;
    /**
     *
     * @type {string}
     * @memberof BookingRewardAuditKey
     */
    userId: string;
}


/**
 * @export
 */
export const BookingRewardAuditKeyBookingTypeEnum = {
    Hotel: 'hotel',
    Vehicle: 'vehicle'
} as const;
export type BookingRewardAuditKeyBookingTypeEnum = typeof BookingRewardAuditKeyBookingTypeEnum[keyof typeof BookingRewardAuditKeyBookingTypeEnum];


/**
 * Check if a given object implements the BookingRewardAuditKey interface.
 */
export function instanceOfBookingRewardAuditKey(value: object): value is BookingRewardAuditKey {
    if (!('bookingType' in value) || value['bookingType'] === undefined) return false;
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function BookingRewardAuditKeyFromJSON(json: any): BookingRewardAuditKey {
    return BookingRewardAuditKeyFromJSONTyped(json, false);
}

export function BookingRewardAuditKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingRewardAuditKey {
    if (json == null) {
        return json;
    }
    return {

        'bookingType': json['booking_type'],
        'bookingId': json['booking_id'],
        'userId': json['user_id'],
    };
}

export function BookingRewardAuditKeyToJSON(json: any): BookingRewardAuditKey {
    return BookingRewardAuditKeyToJSONTyped(json, false);
}

export function BookingRewardAuditKeyToJSONTyped(value?: BookingRewardAuditKey | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'booking_type': value['bookingType'],
        'booking_id': value['bookingId'],
        'user_id': value['userId'],
    };
}

